import React, {useMemo} from 'react';

import DataView from 'analysis-tool/data-view/DataView';
import DataViewContext from 'analysis-tool/data-view/DataViewContext';
import {assertAndContinue, assert} from 'Asserts';
import MarkdownContent from 'ui-library/MarkdownContent';
import {assertNever} from 'util/Types';

import ConfigFormBlock from './ConfigFormBlock';
import {useDataLayoutContext} from './DataLayoutContext';
import {Block} from './DataLayoutTypes';

interface GridBlockProps {
  block: Block;
  layoutPath: Array<string | number>;
}

/** @package */
export default function GridBlock({block, layoutPath}: GridBlockProps): JSX.Element | null {
  const {actionOrigin} = useDataLayoutContext();
  const dataViewContextValue = useMemo(() => {
    if (block.type === 'DATA_VIEW') {
      return {
        actionOrigin,
        analysisView: block.view,
      };
    } else {
      return null;
    }
  }, [actionOrigin, block]);

  if (block.type === 'CONFIG_FORM') {
    return <ConfigFormBlock block={block} layoutPath={layoutPath} />;
  } else if (block.type === 'DATA_VIEW') {
    assert(dataViewContextValue != null, 'Data view context value should be set for DATA_VIEW blocks');
    return (
      <DataViewContext.Provider value={dataViewContextValue}>
        <DataView />
      </DataViewContext.Provider>
    );
  } else if (block.type === 'MARKDOWN') {
    return <MarkdownContent content={block.markdown} />;
  } else {
    assertAndContinue(false, 'Found unexpected block type in layout', {
      blockType: assertNever(block).type,
    });
    return null;
  }
}
